import { Analytics } from '@repo/analytics/src/Analytics';

export const analytics = new Analytics(import.meta.env.VITE_SEGMENTS_WRITE_KEY);
